module.exports = __webpack_public_path__ + "img/foton56black.422286a3.png";